import { Link, Navigate, useParams } from 'react-router-dom';
import { SIGNUP_URL } from '../config';
import { getStory } from '../content/stories';

export function StoryPage() {
  const { slug } = useParams();
  const story = slug ? getStory(slug) : undefined;
  if (!story) return <Navigate to="/stories" replace />;

  return (
    <article className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[720px]">
        <Link to="/stories" className="mb-6 inline-block text-[0.82rem] font-semibold text-ink-3 hover:text-brand">
          ← How it is used
        </Link>
        <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">{story.label}</p>
        <h1 className="font-display mb-4 text-[2.25rem] leading-[1.1] font-extrabold text-ink lg:text-[2.75rem]">
          {story.title}
        </h1>
        <p className="mb-10 text-[1.05rem] leading-[1.7] text-ink-3">{story.summary}</p>
        <div className="mk-stagger space-y-4">
          {story.steps.map((step, i) => (
            <div key={step.title} className="mk-lift rounded-2xl border border-line bg-panel p-5 shadow-sm">
              <div className="mb-1 font-mono-data text-[0.65rem] font-bold text-brand">0{i + 1}</div>
              <h2 className="font-display mb-2 text-[1rem] font-bold text-ink">{step.title}</h2>
              <p className="text-[0.9rem] leading-[1.7] text-ink-3">{step.body}</p>
            </div>
          ))}
        </div>
        <a
          href={SIGNUP_URL}
          className="mt-10 inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 font-semibold text-brand-on hover:bg-brand-hover"
        >
          Start free
        </a>
      </div>
    </article>
  );
}
